var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCircle20(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.121 9.243a1 1 0 10-1.414 1.414l2.121 2.121a1 1 0 001.415 0l3.535-3.535a1 1 0 00-1.414-1.415l-2.828 2.829L8.12 9.243z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAxOEMxNC40MTgzIDE4IDE4IDE0LjQxODMgMTggMTBDMTggNS41ODE3MiAxNC40MTgzIDIgMTAgMkM1LjU4MTcyIDIgMiA1LjU4MTcyIDIgMTBDMiAxNC40MTgzIDUuNTgxNzIgMTggMTAgMThaTTguMTIxMzIgOS4yNDI2NkM3LjczMDggOC44NTIxNCA3LjA5NzYzIDguODUyMTQgNi43MDcxMSA5LjI0MjY2QzYuMzE2NTggOS42MzMxOSA2LjMxNjU4IDEwLjI2NjQgNi43MDcxMSAxMC42NTY5TDguODI4NDMgMTIuNzc4MkM5LjIxODk1IDEzLjE2ODcgOS44NTIxMiAxMy4xNjg3IDEwLjI0MjYgMTIuNzc4MkwxMy43NzgyIDkuMjQyNjZDMTQuMTY4NyA4Ljg1MjE0IDE0LjE2ODcgOC4yMTg5NyAxMy43NzgyIDcuODI4NDVDMTMuMzg3NyA3LjQzNzkyIDEyLjc1NDUgNy40Mzc5MiAxMi4zNjQgNy44Mjg0NUw5LjUzNTUzIDEwLjY1NjlMOC4xMjEzMiA5LjI0MjY2WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgCheckCircle20 as ReactComponent };